import { render, staticRenderFns } from "./OrderNotes.vue?vue&type=template&id=10ebfad7&scoped=true&"
import script from "./OrderNotes.vue?vue&type=script&lang=js&"
export * from "./OrderNotes.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotes.vue?vue&type=style&index=0&id=10ebfad7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ebfad7",
  null
  
)

export default component.exports